// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onfido-sdk-ui-CustomFileInput-container{position:relative;cursor:pointer}.onfido-sdk-ui-CustomFileInput-input{bottom:0;left:0;display:none !important;position:absolute;right:0;top:0;width:100%;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "onfido-sdk-ui-CustomFileInput-container",
	"input": "onfido-sdk-ui-CustomFileInput-input"
};
export default ___CSS_LOADER_EXPORT___;
